import React, { useContext } from 'react';
import { VehicleContext } from '../../context/VehicleContext';
import { CustomerContext } from '../../context/CustomerContext';
import PageTitle from '../common/PageTitle';
import PolicySection from './PolicySection';
import PersonalDetailSection from './PersonalDetailSection';
import ProgressButton from '../common/ProgressButton';
import { RoutePaths, UserInfo } from '../../Constants/Common';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { SiteContext } from '../../context/SiteContext';
import { useTranslation } from 'react-i18next';

const Dashboard = (): JSX.Element => {
    const { user } = useAuth0();

    const { vehicles } = useContext(VehicleContext);
    const { customer } = useContext(CustomerContext);
    const { brandId } = useContext(SiteContext);

    const navigate = useNavigate();

    const { t } = useTranslation();

    const onBackToSearchClicked = () => {
        const userKey = `${user?.sub || ''}_${brandId}`;
        localStorage.setItem(`${userKey}_${UserInfo.Surname}`, '');
        localStorage.setItem(`${userKey}_${UserInfo.Postcode}`, '');

        navigate(RoutePaths.Home);
    };

    return (
        <>
            <div className='card page-content'>
                <PageTitle title={t('your_details')} />
                {vehicles === undefined || vehicles.length === 0 ? (
                    <>
                        <p className='p-3 m-0'>
                            {t('details_not_found_message')}
                        </p>

                        <ProgressButton
                            onClick={onBackToSearchClicked}
                            navRoute={RoutePaths.Home}
                            buttonStyle={'btn btn-primary progress-button'}
                            text={t('back_to_search')}
                        />
                    </>
                ) : (
                    <>
                        <p className='p-3 m-0'>
                            {t('personal_details_section_title')}
                        </p>
                        <div className='page-content-body'>
                            <PersonalDetailSection customer={customer} />
                            <PolicySection vehicles={vehicles} />
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default Dashboard;
